import ShipmentsApi from '../../../../API/shipment/shipments-api';
import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../constans';
import { getDate } from '../../../../utils';
import styles from './styles.module.scss';

const DeleteShipmentPopUp = ({ shipment = {}, close = () => { } }) => {
  const clickDelete = async () => {
    await ShipmentsApi.deleteShipment({ data: { shipmentId: shipment.id } }).then(() => {
      close();
    });
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Вы уверены что хотите удалить отгрузку {shipment.market}/{shipment.shop} ({getDate(shipment.time_scheduled)})?</H2>

      <Row style={{ marginTop: '30px' }}>
        <Button type={TYPE_BUTTONS.BLUE} style={{ marginRight: '20px' }} onClick={() => clickDelete()}>
          Удалить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default DeleteShipmentPopUp;
